import styled from 'styled-components';

export const StyledWrapper = styled.div`
  background: #fff;
  padding: 16px 24px;
  height: 100%;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: flex-end;
  height: 100%;
  margin-bottom: 24px;
`;

export const StyledTitle = styled.div`
  color: #4c4b4b;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 111.111% */
`;

export const StyledSubTitle = styled.div`
  color: #232323;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  margin-left: 26px;
`;

export const StyledContent = styled.div`
  display: flex;
  gap: 16px;
`;

export const StyledContentHeader = styled.div`
  color: #242424;
  /* Large/16M */
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 125% */
  &&& .emp-ant-select-selector {
    color: #0046ff;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */
  }
`;

export const StyledSummaryCard = styled.div`
  margin-top: 14px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  background: #fff;
`;

export const StyledDivider = styled.div`
  width: 100%;
  display: flex;
  height: 1px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background: #d9d9d9;
`;

export const StyledSummaryCardTitle = styled.div`
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  margin-bottom: 14px;
`;

export const StyledIssueEventTitle = styled.span`
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const StyledCoverageDetailWrapper = styled.div`
  width: 70%;
`;

export const StyledTableCard = styled.div`
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  background: #fff;
  padding: 18px 16px 12px 6px;
  margin-top: 12px;
`;

export const StyledTableTitle = styled.div`
  color: rgba(0, 0, 0, 0.88);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 100% */
  margin-left: 12px;
  margin-bottom: 24px;
`;

export const StyledTableIndexHeader = styled.div`
  width: 100%;
  padding: 9px 0;
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledTableHeader = styled.div`
  width: 100%;
  padding: 9px 0;
  color: rgba(0, 0, 0, 0.88);
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
